import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoaderComponent } from './loader/loader.component';
import {AppTelephoneFormatterDirective} from '@app/shared/telephone-mask/telephone.directive';
import {TelephoneService} from '@app/shared/telephone-mask/telephone.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    LoaderComponent,
    AppTelephoneFormatterDirective
  ],
  exports: [
    LoaderComponent,
    AppTelephoneFormatterDirective
  ],
  providers: [
    TelephoneService
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/shared/shared.module.ts